// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__3o4nf","contactNav":"NavigationItems_contactNav__2LWWE","active":"NavigationItems_active__2a1YO"};